import React from "react";
import { Typography as MuiTypography } from "@mui/material";
import styled from "styled-components/macro";
import { display, flexbox, sizing, spacing } from "@mui/system";

const Typography = styled(MuiTypography)(spacing, sizing, display, flexbox);

const FieldView = ({ title, value }) => (
  <>
    <Typography variant="caption">{title}</Typography>
    <Typography variant="body2" component="div" maxWidth="400px" noWrap>
      {value?.toString()}
    </Typography>
  </>
);

export default FieldView;
